module.exports = __webpack_public_path__ + "img/yiseung.dadd7918.png";